import VerificationSuccess from "../../components/Auth/VerificationSuccess";
function VerificationSuccessPage() {
    return <VerificationSuccess />;
}
export default VerificationSuccessPage;